module.exports = __webpack_public_path__ + "0cca30e06bbd3223f893bcb8866479dd.glb";